// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"1874":"pg-proposals","2451":"pg-event-detail","9547":"pg-contact"}[chunkId] || chunkId) + "." + {"1874":"6a373101","2105":"9efc18cc","2451":"52f25d10","4307":"cc3c1851","5560":"7f6be5a1","5775":"5a425293","7383":"6a373101","9112":"6a373101","9547":"6a373101"}[chunkId] + ".chunk.css";
};